import React from "react";
import {Avatar as PrimeAvatar} from "primereact/avatar";
import {AvatarGroup as PrimeAvatarGroup} from "primereact/avatargroup";

const DEFAULT_MAX_VISIBLE = 5;

export default function AvatarGroup({
    children,
    className = "",
    counterClassName = "",
    maxVisible = DEFAULT_MAX_VISIBLE,
    dir = "rtl",
    ...props
}) {
    const avatars = React.Children.toArray(children);
    const visibleCount = Math.max(0, Number(maxVisible) || DEFAULT_MAX_VISIBLE);
    const visibleAvatars = avatars.slice(0, visibleCount);
    const remainingCount = Math.max(0, avatars.length - visibleAvatars.length);
    const referenceAvatar = visibleAvatars[visibleAvatars.length - 1];
    const referenceProps = React.isValidElement(referenceAvatar)
        ? referenceAvatar.props
        : {};
    const directionClassName = dir === "ltr" ? "ltr" : "rtl";
    const overlapClassName = dir === "ltr" ? "-ml-2" : "-mr-2";

    return (
        <PrimeAvatarGroup
            {...props}
            dir={dir}
            className={`${directionClassName} flex justify-content-start ${className}`.trim()}
        >
            {visibleAvatars.map((avatar, index) => (
                <span
                    key={avatar.key || `avatar-${index}`}
                    className={`relative inline-flex flex-none ${index > 0 ? overlapClassName : ""}`.trim()}
                >
                    {avatar}
                </span>
            ))}
            {remainingCount > 0 && (
                <PrimeAvatar
                    label={`+${remainingCount}`}
                    shape="circle"
                    size={referenceProps.size}
                    style={referenceProps.style}
                    aria-label={`+${remainingCount}`}
                    className={`${overlapClassName} border-1 border-dashed border-300 surface-card text-600 text-xs font-bold flex-none ${referenceProps.className || ""} ${counterClassName}`.trim()}
                />
            )}
        </PrimeAvatarGroup>
    );
}
